import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

const POS_LABELS = { QB: 'QB Streamers', DEF: 'DST Streamers', TE: 'TE Streamers', WR: 'Flex Streamers' };
const POS_ICONS  = { QB: '🏈', DEF: '🛡️', TE: '🎯', WR: '⚡' };

export default function LORStreamerHub({ api }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activePos, setActivePos] = useState('QB');

  useEffect(() => {
    setLoading(true);
    fetch(`${api}/api/lor/intel/streamers`)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError('Could not load streamer data.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Finding this week's streamers…</div>;
  if (error)   return <div className="lor-empty">{error}</div>;
  if (!data)   return null;

  const categories = data.categories || {};
  const positions  = Object.keys(POS_LABELS).filter(p => categories[p]?.length > 0);

  return (
    <div>
      <div className="lor-page-header">
        <h2 className="lor-page-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon emoji="⚡" size={18} /> Streamer Hub</h2>
        <div className="lor-page-meta">Week {data.current_week}</div>
      </div>

      <div className="lor-intel-meta">
        Available players only · <span className="lor-generated-badge">rules-based</span>
      </div>

      <div className="lor-streamer-tabs">
        {positions.map(pos => (
          <button
            key={pos}
            className={`lor-streamer-tab${activePos === pos ? ' active' : ''}`}
            onClick={() => setActivePos(pos)}
          >
            <Icon emoji={POS_ICONS[pos]} size={16} style={{ verticalAlign: 'middle', marginRight: 4 }} /> {POS_LABELS[pos]}
          </button>
        ))}
      </div>

      <div className="lor-streamer-grid">
        {(categories[activePos] || []).map((player, i) => (
          <StreamerCard key={i} player={player} rank={i + 1} />
        ))}
        {(categories[activePos] || []).length === 0 && (
          <div className="lor-empty">No {POS_LABELS[activePos]} available this week.</div>
        )}
      </div>
    </div>
  );
}

function StreamerCard({ player, rank }) {
  const isStream = player.action === 'stream';
  const riskClass = player.risk?.toLowerCase();

  return (
    <div className={`lor-card lor-streamer-card${isStream ? ' lor-streamer-card--stream' : ' lor-streamer-card--stash'}`}>
      <div className="lor-streamer-card-top">
        <div className="lor-streamer-rank">#{rank}</div>
        <div className="lor-streamer-player">
          <div className="lor-streamer-name">{player.full_name}</div>
          <div className="lor-streamer-meta">{player.position} · {player.team}</div>
        </div>
        <div className={`lor-streamer-action lor-streamer-action--${isStream ? 'stream' : 'stash'}`}>
          {isStream ? <><Icon emoji="⚡" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Stream</> : <><Icon emoji="📦" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Stash</>}
        </div>
      </div>

      <div className="lor-streamer-stats">
        <div className="lor-streamer-stat">
          <span className="lor-streamer-stat-val">{player.projected}</span>
          <span className="lor-streamer-stat-lbl">Floor avg</span>
        </div>
        <div className="lor-streamer-stat lor-streamer-stat--ceil">
          <span className="lor-streamer-stat-val">{player.projected_ceiling}</span>
          <span className="lor-streamer-stat-lbl">Ceiling</span>
        </div>
        <div className="lor-streamer-stat">
          <span className={`lor-streamer-risk lor-streamer-risk--${riskClass}`}>{player.risk}</span>
          <span className="lor-streamer-stat-lbl">Risk</span>
        </div>
      </div>

      <div className="lor-streamer-reasoning">{player.reasoning}</div>
      <div className="lor-generated-tag">⚙️ rules-based</div>
    </div>
  );
}
